export default __webpack_public_path__ + "static/media/id.2f7e76b5.png";